import React from 'react';

import useSurvey from './useSurvey';

import { 
  Content, 
  Card, 
  Question, 
  Title, 
  RadioWrap, 
  Label, 
  InfoLabel, 
  Radio, 
  AgreeWrap, 
  AgreeLabel, 
  Checkbox, 
  InfoQuestion, 
  InfoRadio, 
  AgreeBtn,
  AgreeContent,
  Information, 
  ColumnRadioWrap,
  ColumnLabel, 
  InputInformation, 
  Input 
} from './styled';

import title01Img from '../images/title-01.png';
import title02Img from '../images/title-02.png';

function FormComponent() {
  const { 
    state, 
    onChangeToRadio, 
    onChangeToCheckbox, 
    onChangeToInfo,  
    handelSubmit 
  } = useSurvey();

  return (
    <Content>
      <Card className="Content">
        <Title> <img src={title01Img} alt="Question text images" /></Title>

        <div>
          <Question>1. 내 명의 청약 통장이 있다</Question>
          <RadioWrap>
            <Label>
              <Radio name="q1" value="있다" checked={state.q1 === '있다'} onChange={onChangeToRadio} />
              <p>있다</p>
            </Label>
            <Label>
              <Radio name="q1" value="없다" checked={state.q1 === '없다'} onChange={onChangeToRadio} />
              <p>없다</p>
            </Label>
          </RadioWrap>
        </div>

        <div>
          <Question>2. 가점 계산을 해본 적이 있다</Question>
          <RadioWrap>
            <Label>
              <Radio name="q2" value="있다" checked={state.q2 === '있다'} onChange={onChangeToRadio} />
              <p>있다</p>
            </Label>
            <Label>
              <Radio name="q2" value="없다" checked={state.q2 === '없다'} onChange={onChangeToRadio} />
              <p>없다</p>
            </Label>
          </RadioWrap>
        </div>

        <div>
          <Question>3. 관심 단지의 모집공고문을 찾아본 적이 있다.</Question>
          <RadioWrap>
            <Label>
              <Radio name="q3" value="있다" checked={state.q3 === '있다'} onChange={onChangeToRadio} />
              <p>있다</p>
            </Label>
            <Label>
              <Radio name="q3" value="없다" checked={state.q3 === '없다'} onChange={onChangeToRadio} />
              <p>없다</p>
            </Label>
          </RadioWrap>
        </div>
      
        <div>
          <Question>4. 공공임대,민간분양 등 청약 접수해 본 적이 있다.</Question>
          <RadioWrap>
            <Label>
              <Radio name="q4" value="있다" checked={state.q4 === '있다'} onChange={onChangeToRadio} />
              <p>있다</p>
            </Label>
            <Label>
              <Radio name="q4" value="없다" checked={state.q4 === '없다'} onChange={onChangeToRadio} />
              <p>없다</p>
            </Label>
          </RadioWrap>
        </div>      
        
        <div>
          <Question>5. 민간분양, 공공분양 청약을 해본적이 없다면 이유는?</Question>
          <ColumnRadioWrap>
            <ColumnLabel>
              <Radio name="q5" value="시도해봤거나 당첨된 적이 있다" checked={state.q5 === '시도해봤거나 당첨된 적이 있다'} onChange={onChangeToRadio} />
              <p>시도해봤거나 당첨된 적이 있다</p>
            </ColumnLabel>
            <ColumnLabel>
              <Radio name="q5" value="분양에 대해 잘 모른다" checked={state.q5 === '분양에 대해 잘 모른다'} onChange={onChangeToRadio} />
              <p>분양에 대해 잘 모른다</p>
            </ColumnLabel>
            <ColumnLabel>
              <Radio name="q5" value="자금이 부족하다" checked={state.q5 === '자금이 부족하다'} onChange={onChangeToRadio} />
              <p>자금이 부족하다</p>
            </ColumnLabel>
            <ColumnLabel>
              <Radio name="q5" value="가점이 낮다" checked={state.q5 === '가점이 낮다'} onChange={onChangeToRadio} />
              <p>가점이 낮다</p>
            </ColumnLabel>
            <ColumnLabel>
              <Radio name="q5" value="자격이 안된다" checked={state.q5 === '자격이 안된다'} onChange={onChangeToRadio} />
              <p>자격이 안된다</p>
            </ColumnLabel>
            <ColumnLabel>
              <Radio name="q5" value="지금 할 생각이 없다" checked={state.q5 === '지금 할 생각이 없다'} onChange={onChangeToRadio} />
              <p>지금 할 생각이 없다</p>
            </ColumnLabel>
          </ColumnRadioWrap>
        </div>
      </Card>

      <Card className="info">
        <Title><img src={title02Img} alt="title" /></Title>

        <Question>경품 발송을 위해 참여하신 분의 정보를 입력해주세요.</Question>

        <InputInformation>
          <p>이름</p>
          <Input name="infoName"  placeholder="홍길동" value={state.infoName} onChange={onChangeToInfo} />
        </InputInformation>

        <InputInformation>
          <p>연락처</p>
          <Input name="infoPhone"  placeholder="숫자로만 입력해주세요" value={state.infoPhone} onChange={onChangeToInfo} />
        </InputInformation>

        <Information>
          <InfoQuestion>연령대</InfoQuestion>
          <InfoRadio>
            <InfoLabel>
              <Radio name="info1" value="20대" checked={state.info1 === '20대'} onChange={onChangeToRadio} />
              <p>20대</p>
            </InfoLabel>
            <InfoLabel>
              <Radio name="info1" value="30대" checked={state.info1 === '30대'} onChange={onChangeToRadio} />
              <p>30대</p>
            </InfoLabel>
            <InfoLabel>
              <Radio name="info1" value="40대" checked={state.info1 === '40대'} onChange={onChangeToRadio} />
              <p>40대</p>
            </InfoLabel>
            <InfoLabel>
              <Radio name="info1" value="50대이상" checked={state.info1 === '50대이상'} onChange={onChangeToRadio} />
              <p>50대이상</p>
            </InfoLabel>
          </InfoRadio>
        </Information>
        
        <Information>
          <InfoQuestion>성별</InfoQuestion>
          <InfoRadio>
            <InfoLabel>
              <Radio name="info2" value="남자" checked={state.info2 === '남자'} onChange={onChangeToRadio} />
              <p>남자</p>
            </InfoLabel>
            <InfoLabel>
              <Radio name="info2" value="여자" checked={state.info2 === '여자'} onChange={onChangeToRadio} />
              <p>여자</p>
            </InfoLabel>
          </InfoRadio>
        </Information>

        <Information>
          <InfoQuestion>혼인여부</InfoQuestion>
          <InfoRadio>
            <InfoLabel>
              <Radio name="info3" value="미혼" checked={state.info3 === '미혼'} onChange={onChangeToRadio} />
              <p>미혼</p>
            </InfoLabel>
            <InfoLabel>
              <Radio name="info3" value="기혼" checked={state.info3 === '기혼'} onChange={onChangeToRadio} />
              <p>기혼</p>
            </InfoLabel>
          </InfoRadio>
        </Information>

        <Question>개인정보 이용 및 처리에 대한 동의</Question>

        <AgreeWrap>
          <AgreeContent>
            <p>￭ 수집하는 개인정보 항목 및 이용목적:</p>
            <p>- 이름, 연락처(본인확인 및 경품 발송)</p>
            <p>- 연령대, 성별, 혼인 여부(대외 보도자료 작성 관련 통계 활용)</p>
            <p>￭ 개인정보 보유 및 이용 기간</p>
            <p>- 경품 발송 후 60일까지</p>
            <p>￭ 개인정보 수집 및 이용에 동의하지 않으실 경우, 본 이벤트 참여가 제한됩니다.</p>
            <p>
              ※ 귀하가 제공한 개인정보는 당사의 개인정보보호정책에 따라 안전하게 보관되며,
              본 이벤트 종료 후 귀하로부터 제공받은 개인정보는 경품발송 용도 이외에 제 3자에게 제공되거나 활용되지 않습니다. 
            </p>
          </AgreeContent>
        <AgreeLabel>
            <p>동의합니다</p>
            <Checkbox name="check" checked={state.check} onChange={onChangeToCheckbox} />
          </AgreeLabel>
          <AgreeBtn onClick={handelSubmit}> 
            참여완료 &gt;
          </AgreeBtn>
        </AgreeWrap>
      </Card>
    </Content>
  );
}

export default FormComponent;
